export default {
	es: {
		['start_here']: 'Inicia Aquí',
		['rent_a_car']: 'Renta tu auto',
		['hashtag_we_move_you']: '#NosotrosTeMovemos',
        ['privacy_policy_notice']: 'Consulta nuestras políticas de privacidad en mexrentar.com/es/aviso-de-privacidad así como los términos y condiciones del servicio en mexrentar.com/es/terminos-y-condiciones',
	},
	en: {
		['start_here']: 'Start Here',
		['rent_a_car']: 'Rent your car',
		['hashtag_we_move_you']: '#WeMoveYou',
        ['privacy_policy_notice']: 'Review our Privacy Policy at mexrentar.com/en/notice-of-privacy and our Terms and Conditions at mexrentar.com/en/terms-and-conditions',
	}
}
